module.exports = __webpack_public_path__ + "art-innovators-alliance.e135ae2d.svg";